// extracted by css-extract-rspack-plugin
var _1 = "Z8GfXwdOzd4w0sagILNQ7w--";
var _2 = "BnVB9cagvM-eE1-koHvBiw--";
var _3 = "Yh8yxJHbIK50r6XzBVQdhw--";
var _4 = "ZyL88VvHE7h9wb-ksv538Q--";
var _5 = "OtlpNaP210A8AJjdFC8vHw--";
var _6 = "dBRfEWyq9L2D3w-OQ1xpmQ--";
export { _1 as "checkBox", _2 as "label", _3 as "labelDisabled", _4 as "noRightMargin", _5 as "partial", _6 as "rightMargin" }
